import { compact, join, map } from "lodash";

export interface DynamicRestQueryOptions {
  filter?: Record<string, any>;
  custom?: Record<string, any>;
  search?: string;
  sort?: string[];
  page?: string;
  pageSize?: string;
  include?: string[];
}

export const dynamicRestQueryOptionToQueryString = (
  option: DynamicRestQueryOptions[keyof DynamicRestQueryOptions] | undefined,
  parseFn: (v: string, k?: string) => string | null,
) => (!option ? "" : join(compact(map(option, parseFn)), "&"));

export const makeQueryString = (options: DynamicRestQueryOptions) => {
  const search = options?.search ? `q=${encodeURI(options.search)}` : null;
  const filter = dynamicRestQueryOptionToQueryString(options?.filter, (v, k) =>
    v
      ? join(
          map(v, v => `filter{${k}}=${v}`),
          "&",
        )
      : null,
  );
  const custom = dynamicRestQueryOptionToQueryString(options?.custom, (v, k) =>
    v
      ? join(
          map(v, v => `${k}=${v}`),
          "&",
        )
      : null,
  );
  const sort = dynamicRestQueryOptionToQueryString(options?.sort, v =>
    v ? `sort[]=${v}` : null,
  );
  const page = options?.page ? `page=${options.page}` : null;
  const pageSize = options?.page ? `page_size=${options.pageSize}` : null;
  const include = dynamicRestQueryOptionToQueryString(options?.include, v =>
    v ? `include[]=${v}` : null,
  );

  return join(
    compact([search, filter, custom, sort, page, pageSize, include]),
    "&",
  );
};

export interface DynamicRestPagination {
  meta: {
    total_results: number;
    total_pages: number;
    page: number;
    per_page: number;
  };
}

export const removeDynamicRestQueryOptionsFromSearch = (
  search: string,
  otherParams: string[] = [],
) => {
  const nonDynamicRestParams: string[] = [];
  search
    .substring(1)
    .split("&")
    .forEach(param => {
      if (
        !["filter", "q", "sort", "page", "page_size", ...otherParams].some(v =>
          param.includes(v),
        )
      ) {
        nonDynamicRestParams.push(param);
      }
    });
  if (!nonDynamicRestParams) {
    return "";
  }
  return join(nonDynamicRestParams, "&");
};
